export const EMPLOYEES_FEATURES = {
  moduleKey: 'employees',
  features: ['employees.view', 'employees.manage'] as const,
  featureMeta: {
    'employees.view': {
      name: 'Employees',
      translations: { name: { de: 'Mitarbeitende', en: 'Employees', fr: 'Employés', it: 'Dipendenti' } },
    },
    'employees.manage': {
      name: 'Manage employees',
      translations: {
        name: { de: 'Mitarbeitende verwalten', en: 'Manage employees', fr: 'Gérer les employés', it: 'Gestire i dipendenti' },
      },
    },
  },
} as const;
